<div class="welcome-container">
  <div class="video-card">
    <video preload="true" autoplay loop [muted]="true">
      <source [src]="welcomeVideoUrl" type="video/mp4" />
    </video>
  </div>
  <div class="welcome-card">
    <div class="welcome-header">
      <div class="logo-container">
        <img [src]="logoPath" alt="Doktar Logo" />
      </div>
      <div class="language-selector">
        <p-select
          [options]="languages"
          [(ngModel)]="selectedLanguage"
          (onChange)="onLanguageChange($event)"
          optionLabel="nativeName"
          dataKey="id"
          placeholder="Select a Language">
        </p-select>
      </div>
    </div>
    <div class="welcome-layout">
      <div class="welcome-content">
        <div class="titles">
          <span class="welcome-title">
            {{ 'doktar_app.auth.welcome.title' | translate }}
          </span>
          <span class="welcome-subtitle">
            {{ 'doktar_app.auth.welcome.subtitle' | translate }}
          </span>
        </div>
        <span class="welcome-description">
          {{ 'doktar_app.auth.welcome.desc' | translate }}
        </span>
      </div>
      <div class="welcome-buttons">
        <button
          pButton
          (click)="onRegister()"
          class="register-button"
          [label]="'doktar_app.auth.register.register' | translate"></button>
        <button
          pButton
          variant="outlined"
          severity="secondary"
          class="login-button"
          (click)="onLogin()"
          [label]="'doktar_app.auth.login.page_title' | translate"></button>
      </div>
      <div class="terms-info">
        <span class="terms-text">
          {{ 'doktar_app.auth.welcome.terms-text' | translate }}
          <a [href]="termsOfUseLink" target="_blank" class="terms-linked-texts">
            {{ 'doktar_app.common.terms-of-use' | translate }}
            and
            {{ 'doktar_app.common.privacy-policy' | translate }}
          </a>
        </span>
      </div>
      <!--
                <div class="welcome-footer">
                    <span class="footer-text">
                        @for (footer of footer_texts; track footer.text) {
                            <a [routerLink]="footer.link" class="footer-text-link">
                                {{ footer.text | translate }}
                            </a>
                            <span *ngIf="footer !== footer_texts[footer_texts.length - 1]">•</span>
                        }
                    </span>
                </div>
            -->
    </div>
  </div>
</div>
